/**
 * Convert ASCII code to character for display
 */
export const getCharFromCode = (code: number): string => {
  // Handle invalid code points (NaN, undefined, null, negative, etc.)
  if (!Number.isFinite(code) || code < 0 || code > 0x10ffff) {
    return "�"; // Unicode replacement character
  }
  return String.fromCodePoint(code);
};

/**
 * Convert character to ASCII code
 */
export const getCodeFromChar = (char: string): number => {
  return char.codePointAt(0) ?? 0;
};
